<template>
  <v-modal full animation="slide-up" fit-content handle-click-bg position="bottom">
    <template v-slot:activator="{ on }">
      <list-item two-columns @click="on()">
        <template v-slot:firstColumn>
          <list-item-group>
            <list-item-icon>
              icon-people
            </list-item-icon>

            <list-item-content>
              <list-item-title>
                <span class="text--regular">{{ $t('widgets.StatSummary.registeredGoldShopUsers') }}</span>
              </list-item-title>
            </list-item-content>
          </list-item-group>
        </template>

        <template v-slot:secondColumn>
          <list-item-title font-medium>
            <span class="text--medium" v-if="$apollo.queries.summary.loading"><PuSkeleton width="10rem" /></span>
            <span class="text--medium" v-else>{{ computedData.amountToday }}</span>
          </list-item-title>
          <list-item-subtitle>
            <span class="text--medium" v-if="$apollo.queries.summary.loading"><PuSkeleton width="5rem" /></span>
            <span class="text--medium" :class="computedClass" v-else>{{computedArrow}}{{ difference !== 0 ? difference + '%' : '-' }}</span>
          </list-item-subtitle>
        </template>
      </list-item>
    </template>

    <template v-slot:header>{{ $t('widgets.StatSummary.registeredGoldShopUsers') }}</template>
    <summary-widget color="#B9AE15" flat source="USERS"></summary-widget>
  </v-modal>
</template>

<script>
import vModal from '@/ui/modals/vModal'

import ListItem from '@/ui/slots/List/ListItem'
import ListItemGroup from '@/ui/slots/List/ListItemGroup'
import ListItemIcon from '@/ui/slots/List/ListItemIcon'
import ListItemContent from '@/ui/slots/List/ListItemContent'
import ListItemTitle from '@/ui/slots/List/ListItemTitle'
import ListItemSubtitle from '@/ui/slots/List/ListItemSubtitle'

import SummaryWidget from '@/widgets/SummaryWidget'

import toCurrency from '@/mixins/toCurrency'
import hasActiveContracts from '@/mixins/hasActiveContracts'
import merchantCurrency from '@/mixins/merchantCurrency'

import mixin from './mixin'

import { SummaryStatGQL } from '@/graphql/queries'

export default {
  mixins: [toCurrency, hasActiveContracts, merchantCurrency, mixin],

  components: {
    ListItem,
    ListItemIcon,
    ListItemContent,
    ListItemTitle,
    ListItemGroup,
    ListItemSubtitle,

    vModal,
    SummaryWidget
  },

  apollo: {
    summary: {
      query: SummaryStatGQL,

      variables () {
        return {
          params: {
            // contractId: this.currContractId,
            stat: this.source
          }
        }
      },

      update: data => data.merchant.stats.summary,

      skip () { return !this.hasActiveContracts }
    }
  },

  data () {
    return {
      source: 'USERS'
    }
  }
}
</script>
